import type { InjectionKey } from 'vue';
import type { IGroupProvide } from '@components/composable';

export const CdsTabsV2Symbol: InjectionKey<IGroupProvide> = Symbol('cds:tabsV2');
